module.exports = __webpack_public_path__ + "img/arrow-black.2f180493.svg";